export default __webpack_public_path__ + "static/mine-free_small-image_2-2350b499fb0928f9dfdb4f12425cf1e2.png";